import { Card, Flex, Spin } from "antd";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useReportEmbedUrl } from "../../../hooks/useReportEmbedUrl";
import ReportError from "./ReportError";

const PaidInvoicesReport = observer(() => {

    const { reportUrl, isLoadReport, loadError } = useReportEmbedUrl("49");

    return <>
            <Flex vertical={true} gap={10}>
            <Link to="/BoardVue/Reports" style={{ marginLeft: 10 }}><ArrowLeftOutlined /> Back</Link>
                <Card>
                    {loadError
                        ? <ReportError message={loadError} />
                        : <iframe id="BV_PaidInvoices" className="reportIframe"
                        src={reportUrl}
                        width="100%"
                        height="2200"
                        allowTransparency={true}
                        frameBorder={0}
                    ></iframe>}
                    {isLoadReport === true && !loadError ? <>
                        <Flex gap="small" vertical>
                            <Spin/>
                        </Flex>
                    </>: <></>}
                </Card>
            </Flex>
    </>
})

export default PaidInvoicesReport
